export function scrollToTop() {
    let behaviorSupported = false;
    try {
        window.scroll({
            // @ts-ignore
            get behavior() {
                behaviorSupported = true;
                return "smooth";
            }
        });
    } catch (err) {
        /* eslint-disable-next-line no-console */
        console.error(err);
    }

    if (behaviorSupported) {
        window.scroll({
            top: 0,
            behavior: "smooth"
        });
    } else {
        window.scroll(0, 0);
    }
}
